export default "__VITE_ASSET__BQfLBRMc__"